import React from 'react';

export const Home = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 17"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.68016 5.46252C1.3335 6.09385 1.3335 6.85719 1.3335 8.38252V9.39719C1.3335 11.9972 1.3335 13.2979 2.11483 14.1059C2.8955 14.9139 4.15283 14.9139 6.66683 14.9139H9.3335C11.8475 14.9139 13.1048 14.9139 13.8855 14.1059C14.6668 13.2979 14.6668 11.9979 14.6668 9.39719V8.38319C14.6668 6.85719 14.6668 6.09452 14.3202 5.46252C13.9748 4.82985 13.3422 4.43785 12.0775 3.65252L10.7442 2.82519C9.4075 1.99519 8.73883 1.58052 8.00016 1.58052C7.2615 1.58052 6.5935 1.99519 5.25616 2.82519L3.92283 3.65252C2.65816 4.43785 2.02616 4.82985 1.68016 5.46252ZM7.50016 12.2472C7.50016 12.3798 7.55284 12.507 7.64661 12.6007C7.74038 12.6945 7.86755 12.7472 8.00016 12.7472C8.13277 12.7472 8.25995 12.6945 8.35372 12.6007C8.44748 12.507 8.50016 12.3798 8.50016 12.2472V10.2472C8.50016 10.1146 8.44748 9.9874 8.35372 9.89363C8.25995 9.79987 8.13277 9.74719 8.00016 9.74719C7.86755 9.74719 7.74038 9.79987 7.64661 9.89363C7.55284 9.9874 7.50016 10.1146 7.50016 10.2472V12.2472Z"
      fill="currentColor"
    />
  </svg>
);
